/**
 * PWA Infrastructure Service
 */
export class PwaService {
  static deferredPrompt = null;
  static isInstalled = false;

  static init() {
    // 1. Check if already running in standalone mode
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
      PwaService.isInstalled = true;
      console.log('[PWA] Running in standalone mode');
    }

    // 2. Register Service Worker
    if ('serviceWorker' in navigator && window.location.protocol.startsWith('http')) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('[PWA] Service Worker registered successfully with scope:', registration.scope);

            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker) {
                installingWorker.onstatechange = () => {
                  if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('[PWA] New content is available; please refresh.');
                  }
                };
              }
            };
          })
          .catch((error) => {
            console.warn('[PWA] Service Worker registration failed:', error);
          });
      });
    }

    // 3. Capture beforeinstallprompt for install banner
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      PwaService.deferredPrompt = e;
      console.log('[PWA] beforeinstallprompt captured, ready for install prompt');
    });

    window.addEventListener('appinstalled', () => {
      PwaService.isInstalled = true;
      PwaService.deferredPrompt = null;
      console.log('[PWA] App successfully installed');
    });

    // 4. Online/Offline Network Status Listeners
    window.addEventListener('online', () => {
      console.log('[PWA] Network status: ONLINE');
    });

    window.addEventListener('offline', () => {
      console.warn('[PWA] Network status: OFFLINE (Operating from Cache)');
    });
  }

  static hasPrompt() {
    return Boolean(PwaService.deferredPrompt);
  }

  static async promptInstall() {
    if (PwaService.deferredPrompt) {
      try {
        PwaService.deferredPrompt.prompt();
        const { outcome } = await PwaService.deferredPrompt.userChoice;
        console.log('[PWA] User response to install prompt:', outcome);
        PwaService.deferredPrompt = null;
        return outcome === 'accepted';
      } catch (err) {
        console.warn('[PWA] prompt error:', err);
        return false;
      }
    }
    return false;
  }
}
